import { Tour } from "antd";
import { TourProps } from "antd/lib";
import classNames from "classnames";
import { useEffect, useLayoutEffect, useState } from "react";
type StateRecord = Record<string, any>;
export interface InteractiveTutorialProps<T extends StateRecord> extends TourProps {
  /** Whether to show Tour in wide mode. */
  isWide?: boolean;
  /** Informs to set state in the parent component. */
  setState?: (state: T) => void;
}
export function InteractiveTutorial<T extends StateRecord>(props: InteractiveTutorialProps<T>) {
  const [stepTick, setStepTick] = useState(0);
  useLayoutEffect(() => {
    if (!props.open || typeof window === "undefined") return;
    window.dispatchEvent(new Event("resize"));
  }, [stepTick, props.open]);

  // Ensure that the Tour is positioned correctly - important for CSS overrides.
  useEffect(() => {
    if (props.open && typeof window !== "undefined") {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 80); // Not happy with magic number - there are better solutions (reacting to render), but this has to do before launch.
    }
  }, [props.open]);
  return <Tour disabledInteraction
  // disabledInteraction already forces all real interaction through the on-screen
  // Next/Previous buttons; Tour's own keyboard arrow-key navigation has no key-repeat guard,
  // so holding an arrow key down can fire many rapid step-advances that look like the tour
  // randomly skipping several steps at once.
  keyboard={false} rootClassName={classNames({
    "shadow-md": true,
    wide: !!props.isWide
  })} zIndex={2000} {...props} steps={props.steps?.map(step => ({
    ...step,
    title: <h2 className="mb-4 text-lg font-semibold">{step.title}</h2>
  }))} onChange={step => {
    setStepTick(tick => tick + 1);
    props.onChange?.(step);
  }} data-sentry-element="Tour" data-sentry-component="InteractiveTutorial" data-sentry-source-file="InteractiveTutorial.tsx" />;
}